// Packages
import React, { useState, useEffect } from "react"
import styled from "styled-components"
import { LayoutGroup } from "framer-motion"
import { graphql } from "gatsby"
import { getMediaQueries } from "@abmg-components"

// Components
import ReviewHeader from "@components/mb-reviews/review-header"
import ReviewCard from "@components/mb-reviews/review-card"
import CorporateReviewCard from "@components/mb-reviews/corporate-review-card"
import VideoReviewCard from "@components/mb-reviews/video-review-card"
import DefaultReviews from "../../utils/default-testimonials"
import ExternalButton from "@components/global/button-external-link"
import InternalButton from "@components/global/button-internal-link"
import SEO from "@components/global/seo"

// Data
import { bankerData } from "@components/global/layout-walled-mb"

// const size = {
//   tablet: 850,
//   mini: 768,
//   mobile: 600,
// }
// const below = Object.keys(size).reduce((acc, label) => {
//   acc[label] = (...args) => css`
//     @media (max-width: ${size[label]}px) {
//       ${css(...args)};
//     }
//   `
//   return acc
// }, {})

const { below } = getMediaQueries()

const Container = styled.div`
  max-width: 1100px;
  padding: 88px 48px;
  margin: 0 auto;
  ${below.mobile`
  padding: 64px 24px;
  `}
`
const ReviewContainer = styled.div`
  display: flex;
  gap: 72px;
  ${below.tablet`
  flex-direction: column;
  `}
`
const Column = styled.div`
  flex: 1;
`
const Gutter = styled.div`
  width: 64px;
  ${below.tablet`
    width: 36px;
  `}
`

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  ${below.mobile`
  flex-direction:column;
  `}
  .contact-button {
    width: unset;
    min-width: 210px;
    margin-right: 32px;
    ${below.mobile`
    max-width:unset;
    margin-right:0;
    margin-bottom:12px;
    `}
  }
  .reviews-button {
    width: unset;
    ${below.mobile`
    max-width:unset;
    margin-right:0;
    `}
  }
`

const Reviews = props => {
  const Page = props.data.PersonnelPage || props.data.TeamPage
  const [ratingData, setRatingData] = useState({
    score: null,
    reviewCount: null,
    microSite:
      Page.birdEyeReviewsMicrosite ||
      Page.reputationUrl ||
      "https://pro.experience.com/reviews/office/atlantic-bay-mortgage-virgnia-beach-46727",
    dataLoaded: false,
  })

  useEffect(() => {
    const fetchExperienceData = async () => {
      let response = await fetch("/.netlify/functions/experience-proxy", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          // profile_id: Page.reputationId,
          agent_email: props.bankerData.individualEmail,
        }),
      })
        .then(res => res.json())
        .catch(() => {
          setRatingData({
            ...ratingData,
            dataLoaded: true,
          })
        })
      if (response) {
        setRatingData({
          reputationId: Page.reputationId,
          score: response.score,
          reviewCount: response.reviewCount,
          microSite:
            response.microSiteType === "user" &&
            (Page.birdEyeReviewsMicrosite || Page.reputationUrl)
              ? Page.birdEyeReviewsMicrosite || Page.reputationUrl
              : `https://pro.experience.com/reviews/office/atlantic-bay-mortgage-virgnia-beach-46727`,
          dataLoaded: true,
        })
      } else {
        setRatingData({
          ...ratingData,
          dataLoaded: true,
        })
      }
    }
    fetchExperienceData()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <ReviewHeader bankerData={props.bankerData} ratingData={ratingData} />

      <Container>
        <ReviewContainer>
          <Column>
            <LayoutGroup>
              {Page.review &&
              Page.review[0].thumbnail &&
              Page.review[0].videoId ? (
                <VideoReviewCard
                  review={Page.review[0].review.childMarkdownRemark.excerpt}
                  reviewer={Page.review[0].reviewer}
                  source={Page.review[0].source}
                  thumbnail={Page.review[0].thumbnail.gatsbyImageData}
                  videoId={Page.review[0].videoId}
                />
              ) : (
                <ReviewCard
                  quoteColor="#FF8255"
                  reviewerColor="#BD432B"
                  excerpt={
                    Page.review
                      ? Page.review[0].review.childMarkdownRemark.excerpt
                      : DefaultReviews[0].excerpt
                  }
                  review={
                    Page.review
                      ? Page.review[0].review.childMarkdownRemark
                          .rawMarkdownBody
                      : DefaultReviews[0].review
                  }
                  reviewer={
                    Page.review
                      ? Page.review[0].reviewer
                      : DefaultReviews[0].reviewer
                  }
                  source={
                    Page.review
                      ? Page.review[0].source
                      : DefaultReviews[0].source
                  }
                />
              )}
              {Page.review &&
              Page.review[1] &&
              Page.review[1].thumbnail &&
              Page.review[1].videoId ? (
                <VideoReviewCard
                  review={Page.review[1].review.childMarkdownRemark.excerpt}
                  reviewer={Page.review[1].reviewer}
                  source={Page.review[1].source}
                  thumbnail={Page.review[1].thumbnail.gatsbyImageData}
                  videoId={Page.review[1].videoId}
                />
              ) : (
                <ReviewCard
                  quoteColor="#A682ED"
                  reviewerColor="#3F1592"
                  excerpt={
                    Page.review && Page.review[1]
                      ? Page.review[1].review.childMarkdownRemark.excerpt
                      : DefaultReviews[1].excerpt
                  }
                  review={
                    Page.review && Page.review[1]
                      ? Page.review[1].review.childMarkdownRemark
                          .rawMarkdownBody
                      : DefaultReviews[1].review
                  }
                  reviewer={
                    Page.review && Page.review[1]
                      ? Page.review[1].reviewer
                      : DefaultReviews[1].reviewer
                  }
                  source={
                    Page.review && Page.review[1]
                      ? Page.review[1].source
                      : DefaultReviews[1].source
                  }
                />
              )}
              {Page.review &&
              Page.review[2] &&
              Page.review[2].thumbnail &&
              Page.review[2].videoId ? (
                <VideoReviewCard
                  review={Page.review[2].review.childMarkdownRemark.excerpt}
                  reviewer={Page.review[2].reviewer}
                  source={Page.review[2].source}
                  thumbnail={Page.review[2].thumbnail.gatsbyImageData}
                  videoId={Page.review[2].videoId}
                />
              ) : (
                <ReviewCard
                  quoteColor="#FFEA9D"
                  reviewerColor="#FDC600"
                  excerpt={
                    Page.review && Page.review[2]
                      ? Page.review[2].review.childMarkdownRemark.excerpt
                      : DefaultReviews[2].excerpt
                  }
                  review={
                    Page.review && Page.review[2]
                      ? Page.review[2].review.childMarkdownRemark
                          .rawMarkdownBody
                      : DefaultReviews[2].review
                  }
                  reviewer={
                    Page.review && Page.review[2]
                      ? Page.review[2].reviewer
                      : DefaultReviews[2].reviewer
                  }
                  source={
                    Page.review && Page.review[2]
                      ? Page.review[2].source
                      : DefaultReviews[2].source
                  }
                />
              )}
              {Page.review &&
              Page.review[3] &&
              Page.review[3].thumbnail &&
              Page.review[3].videoId ? (
                <VideoReviewCard
                  review={Page.review[3].review.childMarkdownRemark.excerpt}
                  reviewer={Page.review[3].reviewer}
                  source={Page.review[3].source}
                  thumbnail={Page.review[3].thumbnail.gatsbyImageData}
                  videoId={Page.review[3].videoId}
                />
              ) : (
                <ReviewCard
                  quoteColor="#60E9C9"
                  reviewerColor="#055461"
                  excerpt={
                    Page.review && Page.review[3]
                      ? Page.review[3].review.childMarkdownRemark.excerpt
                      : DefaultReviews[3].excerpt
                  }
                  review={
                    Page.review && Page.review[3]
                      ? Page.review[3].review.childMarkdownRemark
                          .rawMarkdownBody
                      : DefaultReviews[3].review
                  }
                  reviewer={
                    Page.review && Page.review[3]
                      ? Page.review[3].reviewer
                      : DefaultReviews[3].reviewer
                  }
                  source={
                    Page.review && Page.review[3]
                      ? Page.review[3].source
                      : DefaultReviews[3].source
                  }
                />
              )}
            </LayoutGroup>
          </Column>
          {/* <Gutter /> */}
          <Column>
            <LayoutGroup>
              {Page.review &&
              Page.review[4] &&
              Page.review[4].thumbnail &&
              Page.review[4].videoId ? (
                <VideoReviewCard
                  review={Page.review[4].review.childMarkdownRemark.excerpt}
                  reviewer={Page.review[4].reviewer}
                  source={Page.review[4].source}
                  thumbnail={Page.review[4].thumbnail.gatsbyImageData}
                  videoId={Page.review[4].videoId}
                />
              ) : (
                <ReviewCard
                  quoteColor="#60E9C9"
                  reviewerColor="#055461"
                  excerpt={
                    Page.review && Page.review[4]
                      ? Page.review[4].review.childMarkdownRemark.excerpt
                      : DefaultReviews[4].excerpt
                  }
                  review={
                    Page.review && Page.review[4]
                      ? Page.review[4].review.childMarkdownRemark
                          .rawMarkdownBody
                      : DefaultReviews[4].review
                  }
                  reviewer={
                    Page.review && Page.review[4]
                      ? Page.review[4].reviewer
                      : DefaultReviews[4].reviewer
                  }
                  source={
                    Page.review && Page.review[4]
                      ? Page.review[4].source
                      : DefaultReviews[4].source
                  }
                />
              )}
              {Page.review &&
              Page.review[5] &&
              Page.review[5].thumbnail &&
              Page.review[5].videoId ? (
                <VideoReviewCard
                  review={Page.review[5].review.childMarkdownRemark.excerpt}
                  reviewer={Page.review[5].reviewer}
                  source={Page.review[5].source}
                  thumbnail={Page.review[5].thumbnail.gatsbyImageData}
                  videoId={Page.review[5].videoId}
                />
              ) : (
                <ReviewCard
                  quoteColor="#FF8255"
                  reviewerColor="BD432B"
                  excerpt={
                    Page.review && Page.review[5]
                      ? Page.review[5].review.childMarkdownRemark.excerpt
                      : DefaultReviews[5].excerpt
                  }
                  review={
                    Page.review && Page.review[5]
                      ? Page.review[5].review.childMarkdownRemark
                          .rawMarkdownBody
                      : DefaultReviews[5].review
                  }
                  reviewer={
                    Page.review && Page.review[5]
                      ? Page.review[5].reviewer
                      : DefaultReviews[5].reviewer
                  }
                  source={
                    Page.review && Page.review[5]
                      ? Page.review[5].source
                      : DefaultReviews[5].source
                  }
                />
              )}
              {Page.review &&
              Page.review[6] &&
              Page.review[6].thumbnail &&
              Page.review[6].videoId ? (
                <VideoReviewCard
                  review={Page.review[6].review.childMarkdownRemark.excerpt}
                  reviewer={Page.review[6].reviewer}
                  source={Page.review[6].source}
                  thumbnail={Page.review[6].thumbnail.gatsbyImageData}
                  videoId={Page.review[6].videoId}
                />
              ) : (
                <ReviewCard
                  quoteColor="#FFEA9D"
                  reviewerColor="#FDC600"
                  excerpt={
                    Page.review && Page.review[6]
                      ? Page.review[6].review.childMarkdownRemark.excerpt
                      : DefaultReviews[6].excerpt
                  }
                  review={
                    Page.review && Page.review[6]
                      ? Page.review[6].review.childMarkdownRemark
                          .rawMarkdownBody
                      : DefaultReviews[6].review
                  }
                  reviewer={
                    Page.review && Page.review[6]
                      ? Page.review[6].reviewer
                      : DefaultReviews[6].reviewer
                  }
                  source={
                    Page.review && Page.review[6]
                      ? Page.review[6].source
                      : DefaultReviews[6].source
                  }
                />
              )}
              {Page.review &&
              Page.review[7] &&
              Page.review[7].thumbnail &&
              Page.review[7].videoId ? (
                <VideoReviewCard
                  review={Page.review[7].review.childMarkdownRemark.excerpt}
                  reviewer={Page.review[7].reviewer}
                  source={Page.review[7].source}
                  thumbnail={Page.review[7].thumbnail.gatsbyImageData}
                  videoId={Page.review[7].videoId}
                />
              ) : (
                <ReviewCard
                  quoteColor="#A682ED"
                  reviewerColor="#3F1592"
                  excerpt={
                    Page.review && Page.review[7]
                      ? Page.review[7].review.childMarkdownRemark.excerpt
                      : DefaultReviews[7].excerpt
                  }
                  review={
                    Page.review && Page.review[7]
                      ? Page.review[7].review.childMarkdownRemark
                          .rawMarkdownBody
                      : DefaultReviews[7].review
                  }
                  reviewer={
                    Page.review && Page.review[7]
                      ? Page.review[7].reviewer
                      : DefaultReviews[7].reviewer
                  }
                  source={
                    Page.review && Page.review[7]
                      ? Page.review[7].source
                      : DefaultReviews[7].source
                  }
                />
              )}
            </LayoutGroup>
          </Column>
        </ReviewContainer>

        <LayoutGroup>
          <ButtonContainer>
            <InternalButton
              linkTo={`/${props.bankerData.slug}/contact`}
              buttonText={
                props.bankerData.category === "team" ||
                props.bankerData.theme.match("team")
                  ? `Talk to us`
                  : `Talk to ${props.bankerData.firstName}`
              }
              className="contact-button"
            />
            <ExternalButton
              linkTo={`${ratingData.microSite}`}
              buttonText="View more reviews"
              className="reviews-button tertiary"
            />
          </ButtonContainer>
        </LayoutGroup>
      </Container>
    </>
  )
}

// Meta tags
export const Head = props => {
  return (
    <SEO
      description={`Testimonials from ${bankerData.name}'s past clients - ${
        bankerData.market
          ? bankerData.market
          : `${bankerData.city}, ${bankerData.state} ${bankerData.zip}`
      }.`}
      title={`${bankerData.name} | Reviews & Testimonials | Atlantic Bay Mortgage Group®`}
      ogImage={bankerData.ogImage && "https:" + bankerData.ogImage.file.url}
      slug={`${bankerData.slug}/reviews`}
    />
  )
}

export const query = graphql`
  query ($slug: String!) {
    PersonnelPage: contentfulPersonnelPage(slug: { eq: $slug }) {
      birdEyeReviewsMicrosite
      reputationId
      review {
        source
        reviewer
        review {
          childMarkdownRemark {
            excerpt(pruneLength: 144)
            rawMarkdownBody
          }
        }
        thumbnail {
          gatsbyImageData(layout: CONSTRAINED)
        }
        videoId
      }
    }
    TeamPage: contentfulTeamPage(slug: { eq: $slug }) {
      reputationUrl
      reputationId
      review {
        source
        reviewer
        review {
          childMarkdownRemark {
            excerpt(pruneLength: 144)
            rawMarkdownBody
          }
        }
        thumbnail {
          gatsbyImageData(layout: CONSTRAINED)
        }
        videoId
      }
    }
  }
`

export default Reviews
